import React from 'react';
import {StyleSheet, View} from 'react-native';

import Text from '../../themed/Text';
import CheckboxComponent from '../../ui-controls/web/CheckBox';

export type CheckBoxProps = {
  checked: boolean;
  onChange: (value: boolean) => void;
  text: string;
  uncheckedStyles?: {textStyle: {}};
};

export function CheckBox({
  checked = false,
  onChange,
  text,
  uncheckedStyles = {textStyle: {}},
}: CheckBoxProps) {
  const styles = StyleSheet.create({
    checkboxContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    checkbox: {
      alignSelf: 'center',
    },
    label: {
      marginHorizontal: 8,
    },
  });
  return (
    <View style={styles.checkboxContainer}>
      <CheckboxComponent
        boxType="square"
        disabled={false}
        checked={checked}
        onChange={onChange}
        style={styles.checkbox}
        lineWidth={1}
      />
      <Text
        variant="body2"
        style={
          checked ? styles.label : [styles.label, uncheckedStyles.textStyle]
        }>
        {text}
      </Text>
    </View>
  );
}
